import React from 'react';
import classes from './Input.module.css';

function Input({ ...rest }) {
  return <input className={classes.input} {...rest} />;
}

export default Input;
